import { render, staticRenderFns } from "./configuration-local-assays-sections-modal-operations-form.vue?vue&type=template&id=620d6494&scoped=true&"
import script from "./configuration-local-assays-sections-modal-operations-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-sections-modal-operations-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-sections-modal-operations-form.scss?vue&type=style&index=0&id=620d6494&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d6494",
  null
  
)

export default component.exports